import React, { useState } from "react";
import * as Icon from "react-feather";
import moment from "moment";

import { H6, P } from "../../atoms/Texts";
import { PrimaryButton } from "../../atoms/Buttons";
import CreateCaseNoteModal from "../../organisms/CreateCaseNoteModal";
import Joyride from "react-joyride";
import { useWalkthrough } from "../../../shared/hooks/useWalkthrough";

export const CaseNotePage = () => {
  const [notes] = useState([]);
  const [showCreateNoteModal, setShowCreateNoteModal] = useState(false);

  const toggleShowCreateNoteModal = () =>
    setShowCreateNoteModal(!showCreateNoteModal);

  const steps = [
    {
      target: ".notes",
      content: "This tabs keeps records on notes written about this case",
    },
    {
      target: ".add-note",
      content: "Click here to create a new note.",
    },
  ];

  const { joyrideProps } = useWalkthrough({
    steps,
    walkthroughKey: "case_detail_notes",
    pageSpecific: true, // Each page tracks separately
  });

  return (
    <>
      <Joyride
        key={joyrideProps.run ? "walkthrough-active" : "walkthrough-inactive"}
        {...joyrideProps}
      />

      <div className="mt-4 notes bg-white p-10">
        <div className="flex justify-between items-center">
          <H6 color="#22202C">
            <Icon.ChevronDown
              color="#442ED0"
              size={18}
              className="mr-3 inline-block"
            />
            Notes
          </H6>
          <PrimaryButton.Light
            className="add-note"
            p="8px 14px"
            onClick={toggleShowCreateNoteModal}
          >
            <Icon.Plus color="#442ED0" size={18} className="mr-3 inline-block" />
            Add Note
          </PrimaryButton.Light>
        </div>
        <div className="p-6">
          {notes?.length > 0 ? (
            <>
              {notes.map((note) => (
                <div
                  key={note.id}
                  className="p-4 mb-6 rounded"
                  style={{
                    background: "#EEEEEE99",
                  }}
                >
                  <div className="flex justify-between">
                    <div>
                      <H6 color="#22202D">{note.title}</H6>
                      <P color="#22202D" className="mt-2">
                        {note.body}
                      </P>
                    </div>
                    <div className="flex">
                      <Icon.Edit2 width={15} className="mr-2 cursor-pointer" />
                      <Icon.Trash2 width={15} className="cursor-pointer" />
                    </div>
                  </div>
                  <P color="#22202D" fontSize="12px" className="text-right mt-4">
                    {moment(note.createdAt).format("ll")}
                  </P>
                </div>
              ))}
            </>
          ) : (
            <div
              className="p-8 text-center"
              style={{
                background: "#EEEEEE99",
              }}
            >
              <P color="#22202D">No notes yet</P>
            </div>
          )}
        </div>
        {showCreateNoteModal && (
          <CreateCaseNoteModal closeModal={toggleShowCreateNoteModal} />
        )}
        {/* {showUpdateCaseNoteModal && (
        <UpdateCaseNoteModal
          closeModal={toggleShowUpdateCaseNoteModal}
          note={selectedNote}
        />
      )}
      {showDeleteCaseNoteModal && (
        <DeleteCaseNoteModal
          closeModal={toggleShowDeleteCaseNoteModal}
          noteId={selectedNote.id}
          organizationId={selectedNote.orgId}
        />
      )} */}
      </div>
    </>
  );
};
